module.exports = __webpack_public_path__ + "b2c6d25d569d5e31fc98532dbaea184e.jpg";